import React from 'react';
import { useLightgallery } from 'react-lightgallery';

const OpenButtonWithHook = props => {
  const { openGallery } = useLightgallery();
  const { image, currentIndex, otherProps } = props;

  const keyDownHandler = event => {
    if (event.key === 'Enter') {
      event.preventDefault();

      openGallery('group1', currentIndex);
    }
  };
  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
      onKeyDown={keyDownHandler}
      onClick={() => openGallery('group1', currentIndex)}
      role="button"
      tabIndex={0}
    >
      <img
        style={{ width: '100%', cursor: 'pointer' }}
        src={image.src}
        alt={image.alt}
        title={image.title}
      />
    </div>
  );
};

export default OpenButtonWithHook;
